export const SITE = {
  promoBar: { enabled: false, text: '', ctaLabel: 'Shop now', ctaPath: '/search' },
  announcement: 'Missing, Replacement, or Return Requests are allowed within 7 business days of delivery.',
  supportEmail: 'info@vidyarthibookbank.com',
  supportPhone: '+91 98481 13298',
  aboutText:
    "VidyarthiKart brings your school's complete book set — textbooks, notebooks and stationery — together in one order and delivers it to your door.",
};

export default SITE;
